export default "__VITE_ASSET__efk7Xdi1__"